import { MarketCountryCode } from '@axo/shared/types';
import { UNSECURED_LOAN_AMOUNT_LIMITS } from '../../../forms/createApplication/constants';

/**
 * @deprecated
 */
export function roundUpToStep(
  marketCountry: string,
  number: number,
): { number: number; message: string } {
  const limit =
    UNSECURED_LOAN_AMOUNT_LIMITS[marketCountry as MarketCountryCode];

  if (!limit) {
    throw new Error('Invalid market country');
  }

  // Ensure the number is within min and max limits
  if (number < limit.min) {
    return {
      number: limit.min,
      message: `The number has been rounded up to minimum amount ${limit.min}`,
    };
  }
  if (number > limit.max) {
    return {
      number: limit.max,
      message: `The number has been rounded down to maximum amount ${limit.max}`,
    };
  }

  // Calculate the remainder when the number is divided by the step
  const remainder = number % limit.step;

  // If there is no remainder, the number is already at a step
  if (remainder === 0) {
    return { number, message: '' };
  }

  // Calculate the number rounded up to the nearest step
  const roundedNumber = number - remainder + limit.step;
  return {
    number: roundedNumber,
    message: `The number has been rounded to nearest ${limit.step}`,
  };
}
